import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { NotificationTemplateModel, ParameterModel } from './model';
import { notificationTemplateAdapter, NotificationTemplateState } from './state';

export const stateName: string = 'notificationTemplate';

export const getError = (state: NotificationTemplateState): any => state.error;

export const getIsLoading = (state: NotificationTemplateState): boolean => state.isLoading;

export const getSelected = (state: NotificationTemplateState): NotificationTemplateModel => state.selected;

export const selectNotificationTemplateState: MemoizedSelector<object, NotificationTemplateState> =
  createFeatureSelector<NotificationTemplateState>(stateName);

export const selectAll: (state: object) => NotificationTemplateModel[] =
  notificationTemplateAdapter.getSelectors(selectNotificationTemplateState).selectAll;

export const selectById = (id: number) =>
  createSelector(selectAll, (problems: NotificationTemplateModel[]) => {
    return problems ? problems.find(p => p.id === id) : null;
  });

export const getParameters = (state: NotificationTemplateState): ParameterModel[] => state.parameters;

export const selectSelected: MemoizedSelector<object, NotificationTemplateModel> = createSelector(
  selectNotificationTemplateState,
  getSelected
);

export const selectError: MemoizedSelector<object, any> = createSelector(selectNotificationTemplateState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectNotificationTemplateState, getIsLoading);

export const selectParameters: MemoizedSelector<object, ParameterModel[]> = createSelector(selectNotificationTemplateState, getParameters);
